import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import MilestoneSwitcherContent from './MilestoneSwitcherContent';
import styles from './MilestoneSwitcher.m.sass';

/**
 * How long does it take a dropdown to animate?
 * That sounds like a lightbulb joke, hah!
 * @type {Number}
 */
var TRANSITION_DURATION = 200;
var MilestoneSwitcher = function MilestoneSwitcher(_ref) {
  var state = _ref.state;
  var showingMilestoneSwitcher = state.showingMilestoneSwitcher;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement(TransitionGroup, null, showingMilestoneSwitcher && /*#__PURE__*/React.createElement(CSSTransition, {
    timeout: TRANSITION_DURATION,
    appear: true,
    classNames: {
      enter: styles.animEnter,
      appear: styles.animEnter,
      exit: styles.animLeave
    }
  }, /*#__PURE__*/React.createElement(MilestoneSwitcherContent, {
    state: state
  }))));
};
export default observer(MilestoneSwitcher);
//# sourceMappingURL=index.js.map
